module.exports = __webpack_public_path__ + "img/internet-examples.e9f3d68e.png";